import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AuthenticationApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  login (username, password): Observable<any> {
    const LoginEndPoint = `${environment.API_URL}/auth/login`
    return this.http.post(LoginEndPoint, { username, password }, this.fuseqHeaders.setHeaders('POST'))
  }

  mfa (access_token): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/auth/mfa`
    return this.http.post(apiEndPoint, { access_token }, this.fuseqHeaders.setHeaders('POST'))
  }

  pre_auth (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/auth/pre_auth`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  logout (): Observable<any> {
    const LoginEndPoint = `${environment.API_URL}/auth/logout`
    return this.http.get(LoginEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  checkname (username): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/auth/checkname?username=${username}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  forgotPassword (username): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/auth/forgotPassword`
    return this.http.post(apiEndPoint, { username }, this.fuseqHeaders.setHeaders('POST'))
  }

  resetPassword (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/auth/resetPassword`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setHeaders('POST'))
  }
}
